export class ExternalScriptRequestInformation {
  itemSetId: number;
  privateId: number;
}
